/* @flow */
import Switch from './Switch';
import ButtonSwitch from './ButtonSwitch';

export default Switch;
export { Switch, ButtonSwitch };
